export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeatureWelcome.vue?vue&type=template&id=65ba74b7&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeatureWelcome.vue?vue&type=template&id=65ba74b7&scoped=true&
// module id = 251
// module chunks = 0